export enum LogoSize {
  small = 'sm',
  medium = 'md',
  large = 'lg',
}
